<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <!-- search booth code -->
    <div class="form-row">
      <div class="col">
        <label>Booth Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" #business_code>
      </div>
      <div class="col">
        <label>Select Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <select class="form-control dropdown_box" [(ngModel)]="selected_month">
          <option *ngFor="let month of month_list_for_last_12_months" [ngValue]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </option>
        </select>
      </div>
      <div class="col">
        <button mat-raised-button color="primary" style="margin-top: 33px;margin-left: 25px;" [disabled]="business_code == null || selected_month == null"
          (click)="getMonthlyReport(business_code.value)">Confirm</button>
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div *ngIf="is_data_available">
      <div *ngIf="milk_product_list != null">
        <div class="row" style="margin-top: 15px;">
          <div class="col" style="    font-weight: 500;color: #278ecd;font-size: 16px;">Overall Month Report</div>
        </div>
        <div class="row">
          <div class="col-9">
            <div class="row" style="background: #97cdef; font-weight: bold">
              <div class="col-2 border-item">S.No</div>
              <div class="col-3 border-item">Product name</div>
              <div class="col-2 border-item">Quanity</div>
              <div class="col-2 border-item">Product price</div>
              <div class="col-3 border-item">Total price</div>
            </div>
            <div class="row" *ngFor="let product of product_list; let product_index=index">
              <div class="col-2 border-item">{{product_index +1 }}</div>
              <div class="col-3 border-item">{{product['product_short_name']}}</div>
              <div class="col-2 border-item">
                <span *ngIf="overall_month_report.hasOwnProperty(product.product_id)">
                  {{overall_month_report[product.product_id]['quantity']}}
                </span>
                <span *ngIf="!overall_month_report.hasOwnProperty(product.product_id)">-</span>
              </div>
              <div class="col-2 border-item">{{product.product_mrp | currency: 'INR'}}</div>
              <div class="col-3 border-item">
                <span *ngIf="overall_month_report.hasOwnProperty(product.product_id)">
                  {{overall_month_report[product.product_id]['price'] | currency: 'INR'}}
                </span>
                <span *ngIf="!overall_month_report.hasOwnProperty(product.product_id)">-</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-9">
            <div class="row">
              <!-- <div class="col-2"></div>
            <div class="col-3"></div>
            <div class="col-2"></div> -->
              <div class="col" style="font-size: 22px;text-align: right;font-weight: 500;margin-top: 4px;">Grand Total</div>
              <div class="col-3 border-item">{{overall_month_total_price | currency: 'INR'}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col"  style="    font-weight: 500;color: #278ecd;font-size: 16px;">Commission details</div>
        </div>
        <div class="row" *ngIf="global_config_dict !=null" style="background: #97cdef; font-weight: bold">
          <!-- <div class="col">S.No</div> -->
          <div class="col border-item">Cash Amount</div>
          <div class="col border-item">Card Amount</div>
          <div class="col border-item">Cash Commission ({{global_config_dict['cash_commission']['value']}}%)</div>
          <div class="col border-item">Card Commission ({{global_config_dict['card_commission']['value']}}%)</div>
          <div class="col border-item">Total Commission</div>
          <div class="col border-item">TDS Deduction ({{global_config_dict['tds']['value']}}%)</div>
          <div class="col border-item">Insurance Detection ({{global_config_dict['agent_insurance_on_commission_deduction']['value']}}%)</div>
          <div class="col border-item">Slip Charge</div>
          <div class="col border-item">Final Amount</div>
        </div>
        <div class="row" *ngIf="global_config_dict !=null">
          <!-- <div class="col">1</div> -->
          <div class="col border-item">{{commission_details['total_cash_amount'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['total_card_amount'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['cash_commission'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['card_commission'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['total_commission'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['tds_amount'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['insurance_amount'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['slip_charge'] | currency: 'INR'}}</div>
          <div class="col border-item">{{commission_details['final_amount'] | currency: 'INR'}}</div>
        </div>
        <div class="row">
          <div class="col"  style="    font-weight: 500;color: #278ecd;font-size: 16px;">Milk products</div>
        </div>
        <div class="row" style="font-weight: bold;font-size: 15px;background: #97cdef;text-align: center;">
          <div class=" border-item col-sm-3" style="max-width: 100px;">Date</div>
          <div class="col">
            <div class="row">
              <div class=" border-item col">
                Product details
              </div>
            </div>
            <div class="row">
              <div class=" border-item col">Product</div>
              <div class=" border-item col">M + E</div>
              <div class=" border-item col">Total qty</div>
              <div class=" border-item col">Product price</div>
              <div class=" border-item col">Total price</div>
            </div>
          </div>
          <div class=" border-item col-sm-3" style="max-width: 150px;">Total amount</div>
        </div>
        <div class="row" *ngFor="let date of milk_product_date_list">
          <div class=" border-item col-sm-3" style="max-width: 100px;">{{date| date:'MMM, d, EEEE'}}</div>
          <div class="col">
            <div class="row" *ngFor="let product of milk_product_list">
              <div class=" border-item col">{{product.product_short_name}}</div>
              <div class=" border-item col">
                <span *ngIf="milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  <span *ngFor="let session of session_list; let last_index=last">
                    <span
                      *ngIf="milk_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'].hasOwnProperty(session.id)">
                      {{milk_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'][session.id]}}
                    </span>
                    <span
                      *ngIf="!milk_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'].hasOwnProperty(session.id)">
                      0
                    </span>
                    <span *ngIf="!last_index"> + </span>
                  </span>
                </span>
                <span *ngIf="!milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  0 + 0
                </span>
              </div>
              <div class=" border-item col">
                <span *ngIf="milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{milk_product_report[date]['product_wise'][product.product_id]['total_quantity_per_product']}}
                </span>
                <span *ngIf="!milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  0
                </span>
              </div>
              <div class=" border-item col">
                {{product.product_mrp | currency: 'INR'}}
              </div>
              <div class=" border-item col">
                <span *ngIf="milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{milk_product_report[date]['product_wise'][product.product_id]['total_price_per_product'] | currency: 'INR'}}
                </span>
                <span *ngIf="!milk_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{0 | currency: 'INR'}}
                </span>
              </div>
            </div>
          </div>
          <div class=" border-item col-sm-3" style="max-width: 150px;">
            {{milk_product_report[date]['date_wise_total_price'] | currency: 'INR'}}</div>
        </div>
        <div class="row">
          <div class="col-sm-3" style="max-width: 100px;"></div>
          <div class="col" style="font-size: 22px;text-align: right;font-weight: 500;margin-top: 4px;">Grand Total</div>
          <div class="border-item col-3" style="max-width: 150px;">
            {{milk_product_total_price | currency: 'INR'}}
          </div>
        </div>
        <div class="row">
          <div class="col"  style="    font-weight: 500;color: #278ecd;font-size: 16px;">Fermented products</div>
        </div>
        <div class="row" style="font-weight: bold;font-size: 15px;background: #97cdef;text-align: center;">
          <div class=" border-item col-sm-3" style="max-width: 100px;"></div>
          <div class="col">
            <div class="row">
              <div class=" border-item col">
                Product details
              </div>
            </div>
            <div class="row">
              <div class="border-item col">Product</div>
              <div class="border-item col">M + E</div>
              <div class="border-item col">Total qty</div>
              <div class="border-item col">Product price</div>
              <div class="border-item col">Total price</div>
            </div>
          </div>
          <div class=" border-item col-sm-3" style="max-width: 150px;">Total amount</div>
        </div>
        <div class="row" *ngFor="let date of fermented_product_date_list">
          <div class=" border-item col-sm-3" style="max-width: 100px;">{{date| date:'MMM, d, EEEE'}}</div>
          <div class="col">
            <div class="row" *ngFor="let product of fermented_product_list">
              <div class=" border-item col">{{product.product_short_name}}</div>
              <div class=" border-item col">
                <span *ngIf="fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  <span *ngFor="let session of session_list; let last_index=last">
                    <span
                      *ngIf="fermented_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'].hasOwnProperty(session.id)">
                      {{fermented_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'][session.id]}}
                    </span>
                    <span
                      *ngIf="!fermented_product_report[date]['product_wise'][product.product_id]['total_quantity_product_per_session'].hasOwnProperty(session.id)">
                      0
                    </span>
                    <span *ngIf="!last_index"> + </span>
                  </span>
                </span>
                <span *ngIf="!fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  0 + 0
                </span>
              </div>
              <div class=" border-item col">
                <span *ngIf="fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{fermented_product_report[date]['product_wise'][product.product_id]['total_quantity_per_product']}}
                </span>
                <span *ngIf="!fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  0
                </span>
              </div>
              <div class=" border-item col">
                {{product.product_mrp | currency: 'INR'}}
              </div>
              <div class=" border-item col">
                <span *ngIf="fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{fermented_product_report[date]['product_wise'][product.product_id]['total_price_per_product'] | currency: 'INR'}}
                </span>
                <span *ngIf="!fermented_product_report[date]['product_wise'].hasOwnProperty(product.product_id)">
                  {{0 | currency: 'INR'}}
                </span>
              </div>
            </div>
          </div>
          <div class=" border-item col-sm-3" style="max-width: 150px;">
            {{fermented_product_report[date]['date_wise_total_price'] | currency: 'INR'}}</div>
        </div>
        <div class="row">
          <div class="col-sm-3" style="max-width: 100px;"></div>
          <div class="col" style="font-size: 22px;text-align: right;font-weight: 500;margin-top: 4px;">Grand Total</div>
          <div class="border-item col-3" style="max-width: 150px;">
            {{fermented_product_total_price | currency: 'INR'}}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
